import { render, staticRenderFns } from "./OrdinalNumeration.vue?vue&type=template&id=4c25ed91&"
import script from "./OrdinalNumeration.vue?vue&type=script&lang=js&"
export * from "./OrdinalNumeration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports